import React, { useRef, useCallback } from 'react';
import { SaveRefProps } from './iTabs'

const SaveRef: React.FC<SaveRefProps> = ({ children = () => null }) => {
    const refs = useRef<Record<string, HTMLElement>>({});
    const getRef = useCallback((name: string) => refs.current[name], []);
    const saveRef = useCallback((name: string) => ((node?: HTMLElement) => {
        if (node) refs.current[name] = node;
    }) as React.LegacyRef<HTMLDivElement>, []);
    return <>{children(saveRef, getRef)}</>;
};

export default SaveRef;
